import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref } from 'vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import useSegment from '@/composables/useSegment'
  import { NewsModule } from '@/store/modules/News'
  import CookieHelper from '@/helpers/CookieHelper'
  import type { NewsItem } from '@/services/interfaces/Content'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AllNews',
  setup(__props) {

  const { newsItemOpened } = useSegment()
  const limit = 15
  const offset = ref(limit)

  const loadingContent = computed(() => newsContent.value === null)
  const newsContent = computed(() => NewsModule.newsContent)
  const newNewsContentLength = computed(() => NewsModule.newNewsContentLength)

  const newsSourceLogos = computed(() => {
    const logoUrls = newsContent.value?.map((news) => {
      return news.source.logoUrl
    })
    return [...new Set(logoUrls)]
  })

  const slicedNewsContent = computed((): NewsItem[] => {
    if (!newsContent.value) return []
    return newsContent.value.slice(0, offset.value)
  })

  const itemSize = computed(() => newsContent.value?.length || 0)
  const openNewsItem = (newsUrl: string, newsId: string) => {
    newsItemOpened(newsUrl, newsId)
  }

  NewsModule.getNewsContent().then((news) => {
    const previousLatestNewsItemId = CookieHelper.getCookieValue('latest_news_item_id')
    if (previousLatestNewsItemId && news) {
      const newLatestNewsItemIdIndex = news[0].id
      if (previousLatestNewsItemId !== newLatestNewsItemIdIndex) {
        const previousLatestNewsItemIdIndex = news.findIndex((news) => news.id === previousLatestNewsItemId)
        NewsModule.setNewNewsContentLength(previousLatestNewsItemIdIndex)
      }
    }
  })

  onMounted(() => {
    if (newsContent.value) {
      const latestNewsItemId = newsContent.value[0].id
      CookieHelper.setCookieValue('latest_news_item_id', `${latestNewsItemId}`)
    }
  })

  onUnmounted(() => {
    NewsModule.resetNewNewsContentLength()
  })

return { __sfc: true,newsItemOpened, limit, offset, loadingContent, newsContent, newNewsContentLength, newsSourceLogos, slicedNewsContent, itemSize, openNewsItem, computed, onMounted, onUnmounted, ref, LoadingSpinner, useSegment, NewsModule, CookieHelper }
}

})